import { createFileRoute } from '@tanstack/react-router'
import { LoginScreen } from '../features/login/LoginScreen'

/** E1 — Login route. Публичный роут (без RequireAuth). */
export const Route = createFileRoute('/login')({
  component: LoginScreen,
})
